module.exports = __webpack_public_path__ + "img/logo.a32e6c2d.gif";